import { useCallback } from "react";

import { GetPageHelpRequest } from "src/api/Tmd.dtos";
import useApi from "src/hooks/api/useApi";

/**
 * Loads the help for a route pattern, filtered by the server to the page's trial/institution scope.
 *
 * Postconditions: No request is made without a route key or while disabled. A page without active
 * help resolves to undefined data rather than an error.
 * Assumptions: Changing the route key or either ID changes the SWR key, so help follows navigation.
 */
const usePageHelp = (
    routeKey: string | undefined,
    trialId: number | undefined,
    institutionId: number | undefined,
    enabled = true
) => {
    const request = useCallback(
        () => new GetPageHelpRequest({ routeKey, trialId, institutionId }),
        [routeKey, trialId, institutionId]
    );

    return useApi("get", enabled && routeKey ? request : undefined, {
        getData: response => response?.data?.model,
        getError: response => (response?.error ?? response?.data)?.responseStatus,
        getAdditionalState: () => ({})
    });
};

export default usePageHelp;
